import http from '@root/utils/axios/admin';

let state = {
    CategoriesList: [],
    Category: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchCategoriesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/api/categories', { params: filter }).then((response) => {
                commit('setCategories', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteCategory({ commit }, id) {
        return http.delete('/api/categories/' + id);
    },

    fetchCategory({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('/api/categories/' + id).then((response) => {
                commit('setCategory', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateCategory({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/categories', data).then((response) => {
                commit('setCategory', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCategoryError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateCategory({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/categories/' + data.id, data).then((response) => {
                commit('setCategory', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCategoryError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setCategories(state, data) {
        state.CategoriesList = data;
    },
    setCategory(state, data) {
        state.Category.data = data;
    },
    setCategoryError(state, error) {

        state.Category.error = error.errors;
    },
    cleanCategoryError(state, error) {
        state.Category.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}